import { render, staticRenderFns } from "./PressService.vue?vue&type=template&id=6c5d8ea7&scoped=true&"
import script from "./PressService.vue?vue&type=script&lang=js&"
export * from "./PressService.vue?vue&type=script&lang=js&"
import style0 from "./PressService.vue?vue&type=style&index=0&id=6c5d8ea7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5d8ea7",
  null
  
)

export default component.exports